import axios from "axios";
import CryptoJS from "crypto-js";
import { getAccessToken } from "../auth/authEffect";
import { BASE_URL } from "../baseUrl/baseURL";

const SECRET_KEY = "843567893696976453275974432697R634976";

const authInstance = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
const TOKEN_REFRESH_INTERVAL = 50 * 1000;
let tokenRefreshTimer = null;
function startTokenRefreshTimer() {
  if (tokenRefreshTimer) {
    clearInterval(tokenRefreshTimer);
  }

  tokenRefreshTimer = setInterval(async () => {
    try {
      await handleTokenRefresh();
    } catch (error) {
      console.error("Automatic token refresh failed:", error);
      stopTokenRefreshTimer();
    }
  }, TOKEN_REFRESH_INTERVAL);
}

function stopTokenRefreshTimer() {
  if (tokenRefreshTimer) {
    clearInterval(tokenRefreshTimer);
    tokenRefreshTimer = null;
  }
}

// authInstance.interceptors.request.use(
//   (config) => {
//     const encryptedAccessToken = localStorage.getItem("accessToken");
//     const accessToken = localStorage.getItem("accessToken");
//     const refreshToken = localStorage.getItem("refreshToken");
//     if (
//       !accessToken ||
//       !refreshToken ||
//       accessToken === "undefined" ||
//       refreshToken === "undefined"
//     ) {
//       window.location.href = "/";
//     }
//     if (encryptedAccessToken) {
//       const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, SECRET_KEY);
//       const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);
//       if (decryptedAccessToken) {
//         config.headers["Authorization"] = `Bearer ${decryptedAccessToken}`;
//       } else {
//         console.log("Failed to decrypt the token.");
//       }
//     } else {
//       console.log("No access token found in localStorage.");
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
authInstance.interceptors.request.use(
  (config) => {
    const publicPaths = ["/auth/login", "/auth/register", "/auth/forgot-password"];

    // Skip token validation for public API routes
    if (publicPaths.some((path) => config.url.includes(path))) {
      return config;
    }

    const encryptedAccessToken = localStorage.getItem("accessToken");
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (
      !accessToken ||
      !refreshToken ||
      accessToken === "undefined" ||
      refreshToken === "undefined"
    ) {
      window.location.href = "/";
    }

    if (encryptedAccessToken) {
      const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, SECRET_KEY);
      const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);
      if (decryptedAccessToken) {
        config.headers["Authorization"] = `Bearer ${decryptedAccessToken}`;
      } else {
        console.log("Failed to decrypt the token.");
      }
    } else {
      console.log("No access token found in localStorage.");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let tokenRefreshPromise = null;
async function handleTokenRefresh() {
  if (!tokenRefreshPromise) {
    const encryptedRefreshToken = localStorage.getItem("refreshToken");
    if (!encryptedRefreshToken) return Promise.reject("No refresh token found");
    const bytes = CryptoJS.AES.decrypt(encryptedRefreshToken, SECRET_KEY);
    const decryptedRefreshToken = bytes.toString(CryptoJS.enc.Utf8);
    tokenRefreshPromise = getAccessToken({ token: decryptedRefreshToken })
      .then((response) => {
        const { accessToken, refreshToken } = response.data;
        const encryptedAccess = CryptoJS.AES.encrypt(
          accessToken,
          SECRET_KEY
        ).toString();
        const encryptedRefresh = CryptoJS.AES.encrypt(
          refreshToken,
          SECRET_KEY
        ).toString();
        localStorage.setItem("accessToken", encryptedAccess);
        localStorage.setItem("refreshToken", encryptedRefresh);
        return accessToken;
      })
      .finally(() => {
        tokenRefreshPromise = null;
      });
  }

  return tokenRefreshPromise;
}

authInstance.interceptors.response.use(
  (response) => {
    if (!tokenRefreshTimer) {
      startTokenRefreshTimer();
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        delete authInstance.defaults.headers.common["Authorization"];
        stopTokenRefreshTimer();
      }
      if (status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const newAccessToken = await handleTokenRefresh();

          const encryptedAccess = CryptoJS.AES.encrypt(
            newAccessToken,
            SECRET_KEY
          ).toString();
          localStorage.setItem("accessToken", encryptedAccess);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return authInstance(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          stopTokenRefreshTimer();
        }
      }
      console.log("Error response:", error.response);
    }
    return Promise.reject(error);
  }
);

export { startTokenRefreshTimer, stopTokenRefreshTimer };
export default authInstance;
